var statusHelper = {
  STATUS_COLORS: {
    active: "green",
    annulled: "red",
    "in development": "orange",
    obsolete: "red",
    "out of production": "red",
    "phase out": "orange",
    "pre production": "orange"
  },
  getStatusColor: function getStatusColor(status) {
    if (!status) return "";
    var key = String(status).toLowerCase();
    var color = statusHelper.STATUS_COLORS[key];
    if (!color) return "";
    return "".concat(color);
  }
};